import { useMemo } from 'react';

import { useQueryParams } from '@/utils';
const QUERY_KEY = 'initialAmount';
const useDefaultAllocationAmount = () => {
  const query = useQueryParams();
  const defaultAllocationAmount = useMemo(() => query.get(QUERY_KEY) || '' , [ query]);
  
  return defaultAllocationAmount;
};

export default useDefaultAllocationAmount;